import AbstractService from 'services/AbstractService';


class RecommendedDataService extends AbstractService {
    constructor() {
        super();
        this.REC_VARS_FETCH_START = 'REC_VARS_FETCH_START';
        this.REC_VARS_FETCH_SUCCESS = 'REC_VARS_FETCH_SUCCESS';
        this.REC_VARS_FETCH_ERROR = 'REC_VARS_FETCH_ERROR';
        this.baseUrl = process.env.REACT_APP_BASE_URL;
    }

    getReducer() {
        return (state = this.getInitialState(), action) => {
            let newState = state;

            switch (action.type) {
                case this.REC_VARS_FETCH_SUCCESS:
                    newState = { recommendedVariables: JSON.parse(action.response) };
                    break;

                default:  // stupid linting rule requires a default case
                    break;
            }
            return newState;
        };
    }

    getInitialState() {
        return {
            recommendedVariables: []
        };
    }

    getStoreKey() {
        return 'recommendedVariables';
    }

    fetchRecommendedVariablesIfNeeded() {
        if (this._shouldFetchRecommendedVariables(this.getMyState(this.getStore().getState()))) {
            this.dispatch({
                type: this.REC_VARS_FETCH_START
            });
        }
    }

    /**
     * Fetch if the sites & facilities have not already been loaded into the store
     * @param state - top level state (not just my sub-state)
     * @returns {boolean}
     */
    _shouldFetchRecommendedVariables(myState) {
        const vars = myState.recommendedVariables;
        let shouldFetch = false;
        if (vars.length === 0) {
            shouldFetch = true;
        }
        return shouldFetch;
    }
}

export default new RecommendedDataService();



// WEBPACK FOOTER //
// ./src/services/RecommendedDataService.js